module.exports = __webpack_public_path__ + "assets/img/Main material (23).c6edbf03.jpg";